import * as React from 'react';
import {Dispatch} from "react";

type siteSettings = {
    siteSettings: any
};

export const Header = ({siteSettings}: siteSettings) => {
    return (
        <>
            <div id="header">
                <div id="header-wrapper" className="row g-3">
                    <div id="logo"><a href={siteSettings.siteAddress}
                                      title={siteSettings.title}>
                        <img src={siteSettings.siteLogo}/>
                    </a>
                    </div>
                    <div id="company-email">{siteSettings.email}</div>
                    <div id="company-phone"><a href={"tel:" + siteSettings.phoneNumber}>{siteSettings.phoneNumber}</a>
                    </div>
                </div>
            </div>
        </>
    );
}
